import Vue from 'vue'
import Vuex from 'vuex'
import firebase from '../db/index.js'
const db = firebase.database()

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    addUser ({ commit, rootState, dispatch }, { lang, payload }) {
      let id = db.ref(`${lang}/`).push().key
      payload.id = id
      dispatch(`save`, { lang, payload })
    },
    save ({ commit, rootState }, { lang, payload }) {
      db.ref(`${lang}/${payload.id}/`)
        .set(payload)
        .catch(err => {
          throw err
        })
    }
  },
  modules: {
  }
})
